var _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSendIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 14,
    viewBox: "0 0 15 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.41743 6.98969L3.23416 6.98969M13.4509 6.62839C13.5186 6.66136 13.5756 6.71272 13.6156 6.77659C13.6555 6.84046 13.6766 6.91427 13.6765 6.98959C13.6765 7.06491 13.6552 7.13869 13.6152 7.2025C13.5752 7.26632 13.5181 7.31759 13.4503 7.35046L1.32526 13.1896C1.25276 13.2245 1.17145 13.2368 1.09188 13.2249C1.01231 13.213 0.938147 13.1775 0.879014 13.1229C0.819881 13.0684 0.778507 12.9973 0.76026 12.919C0.742013 12.8406 0.747735 12.7586 0.776682 12.6835L2.91106 7.13347C2.94664 7.04092 2.94664 6.93846 2.91106 6.84591L0.777213 1.29536C0.74852 1.22038 0.74297 1.13852 0.76128 1.06035C0.77959 0.982182 0.820918 0.9113 0.879926 0.856862C0.938934 0.802424 1.01291 0.766931 1.0923 0.754968C1.17168 0.743004 1.25283 0.755121 1.32526 0.789751L13.4509 6.62839Z",
    stroke: "url(#paint0_linear_6776_17114)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6776_17114",
    x1: 4.26764,
    y1: -0.992052,
    x2: 10.4888,
    y2: 5.40187,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#90C5FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1B73CA"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendIcon);
export default __webpack_public_path__ + "static/media/send_icon.e27f8d226ca05830740dd58ba63665e4.svg";
export { ForwardRef as ReactComponent };